import "./loading.sass";

export default function Loading({type}) {
  return (
    <div className="loading" style={{ height: type ? type +"px": 'auto' }}>
      <div className="container-loading">
        <div className="loadingIndicator"></div>
      </div>
    </div>
  );
}
